import { add as addRequest } from 'serviceWorker/db/httpRequests';
import {
  HttpRequestModelType,
  HttpRequestStatus,
} from 'shared/domain/httpRequest/httpRequestModel';
import { ReorderChecklistItemOutDto } from 'shared/dtos/out/template';
import { InspectionTemplateChecklistItemHttpReorderRequestModel } from '../httpQueue/inspectionTemplate/types';

export class InspectionTemplateChecklistItemReorderer {
  constructor(
    private addRequest: (
      request: InspectionTemplateChecklistItemHttpReorderRequestModel
    ) => Promise<unknown>
  ) {}

  async execute(
    templateId: string,
    checklistItemId: string,
    reorderDto: ReorderChecklistItemOutDto,
    projectId: string,
    uniqueId: string
  ): Promise<void> {
    await this.addRequest({
      createdAt: Date.now(),
      method: 'PUT',
      data: {
        reorderDto,
        uniqueId,
        templateId,
        checklistItemId,
        projectId,
      },
      url: `/project/${projectId}/inspectionTemplate/${templateId}/checklistItem/${checklistItemId}/reorder`,
      entityType: HttpRequestModelType.inspectionTemplate,
      status: HttpRequestStatus.NEW,
    });
  }
}

export const inspectionTemplateChecklistItemReorderer =
  new InspectionTemplateChecklistItemReorderer(addRequest);
